import React, { Component } from 'react';

import SectionList from './Section/SectionList';
import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';

class SectionAbout extends Component {

  render() {

    const { $$data, barOffset, horizontalOffset, width } = this.props;
    const align = 'center';

    const listProps = {data: $$data, barOffset, align, className: 'SectionAbout', title: 'Lobster, c\'est...', titleIcon: 'about', titleColor: '#fff', titleAlign: 'right', sectionBg: true, showContent: false, titleSize: width, forceNumber: true};
    return (
      <SectionList id="apropos" header={<div style={{height: 115}}>
        <SectionCorner length={50} style={{top: 66, marginLeft: 0}} corner={'tl'} color={'#fff'} />
        <SectionBar length={Math.round(barOffset/2+horizontalOffset)-56} style={{top: 56, marginLeft: 56}} color={'#fff'} direction={'horizontal'}/>
        <SectionCorner length={50} style={{marginLeft: ((barOffset-58))}} corner={'bl'} color={'#fff'}/>
      </div>
    } barColor={'#fff'} style={this.props.style || {}} {...listProps}  />
  );
}
}

export default SectionAbout;



// WEBPACK FOOTER //
// ./src/components/Home/SectionAbout.jsx